import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Products from "./pages/Products";
import Services from "./pages/Services";
import TankFabrication from "./pages/TankFabrication";
import MechanicalPolishing from "./pages/MechanicalPolishing";
import Electropolishing from "./pages/Electropolishing";
import Portfolio from "./pages/Portfolio";
import Industries from "./pages/Industries";
import Contact from "./pages/Contact";
import Affiliations from "./pages/Affiliations";
import NotFound from "./pages/NotFound";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import CookiePolicy from "./pages/CookiePolicy";
import POTerms from "./pages/POTerms";
import TankVolumeCalculator from "./pages/HeadVolumeCalculator";
import TankWeightCalculator from "./pages/TankWeightCalculator";
import Tools from "./pages/Tools";
import WhatsAppFloat from "./components/WhatsAppFloat";
import CookieConsent from "./components/CookieConsent";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <HelmetProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/products" element={<Products />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/tank-fabrication" element={<TankFabrication />} />
            <Route path="/services/mechanical-polishing" element={<MechanicalPolishing />} />
            <Route path="/services/electropolishing" element={<Electropolishing />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/affiliations" element={<Affiliations />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/tools" element={<Tools />} />
            <Route path="/tools/tank-volume-calculator" element={<TankVolumeCalculator />} />
            <Route path="/tools/tank-weight-calculator" element={<TankWeightCalculator />} />
            {/* Redirect old volume calculator route */}
            <Route path="/head-volume-calculator" element={<TankVolumeCalculator />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/po-terms" element={<POTerms />} />
            
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
          <WhatsAppFloat />
          <CookieConsent />
        </BrowserRouter>
      </TooltipProvider>
    </HelmetProvider>
  </QueryClientProvider>
);

export default App;